import * as React from 'react'
import classnames from 'classnames'

import {
  FaIcon,
  faChevronRight,
  faChevronLeft,
  faChevronsLeftSolid,
  faChevronsRightSolid,
} from '@/lib/fa'
import { TABS } from '../../views/Daily'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const DailyNavigation = ({
  currentDate,
  goToDate,
  onShiftHour,
  activeTab,
  setActiveTab,
}: {
  currentDate: string
  goToDate: (days: number) => void
  onShiftHour?: (hours: number) => void
  activeTab: string
  setActiveTab: (tab: string) => void
}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between  tw-bg-white tw-px-5 tw-py-3">
      <div className="tw-flex tw-items-center tw-gap-1">
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate(-1)}
        >
          <FaIcon icon={faChevronsLeftSolid} className="tw-h-[10px]" />
        </div>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => onShiftHour?.(-1)}
        >
          <FaIcon icon={faChevronLeft} className="tw-h-[10px]" />
        </div>
        <p className="tw-px-2 tw-text-base tw-font-semibold tw-text-content-base">
          {currentDate}
        </p>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => onShiftHour?.(1)}
        >
          <FaIcon icon={faChevronRight} className="tw-h-[10px]" />
        </div>
        <div
          className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
          onClick={() => goToDate(1)}
        >
          <FaIcon icon={faChevronsRightSolid} className="tw-h-[10px]" />
        </div>
      </div>
      <div>
        <div className="tw-items-cener tw-px-4 tw-flex tw-flex-shrink-0 tw-gap-4 ">
          <div
            className={classnames(
              'tw-cursor-pointer tw-rounded tw-border-0 tw-px-4 tw-py-2 tw-transition-colors',
              activeTab === TABS.ActivitiesSlot1
                ? 'active tw-bg-primary tw-text-white'
                : 'tw-bg-base-200 tw-text-content-base',
            )}
            onClick={() => setActiveTab(TABS.ActivitiesSlot1)}
          >
            {t('dailyActivities.slot1')}
          </div>
          <div
            className={classnames(
              'tw-cursor-pointer tw-rounded tw-border-0 tw-px-4 tw-py-2 tw-transition-colors',
              activeTab === TABS.ActivitiesSlot2
                ? 'active tw-bg-primary tw-text-white'
                : 'tw-bg-base-200 tw-text-content-base hover:tw-bg-base-300 ',
            )}
            onClick={() => setActiveTab(TABS.ActivitiesSlot2)}
          >
            {t('dailyActivities.slot2')}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DailyNavigation
